export enum EStorageProvider {
  S3,
  OVH,
  Oracle = 3,
}
